<template>
  <div class="site-container weixin-container">
    <van-nav-bar
      title="微信登录"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      fixed
      class="fixedapp"
    />
    <div class="weixin-content">
      <!-- {{result}} -->
      <!-- <h3>微信登录</h3> -->
      <van-loading v-if="loginLoading">登录中...</van-loading>
      <div class="login-message">
        <div class="message">{{ message }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import { NavBar, Loading } from 'vant';
export default {
  mixins: [],
  components: {
    [NavBar.name]: NavBar, [Loading.name]: Loading
  },
  props: {
    result: String
  },
  data () {
    return {
      loginLoading: true,
      message: '',
      showEmp: false,

      // 返回参数
      openid: null
    }
  },
  computed: {
    ...mapGetters(['backRoute']),
    resultok() {
      let result = this.result;
      if (result) {
        result = decodeURI(result);
        result = JSON.parse(result);
      }
      return result || {};
    },
  },
  mounted () {
    this.loginLoading = true;
    this.message = '';

    // 登录成功
    if (this.resultok.success) {
      this.loginLoading = true;
      // 通过token登录
      this.$store.dispatch(types.JY_LOGIN_MEMBER, {
        token: this.resultok.token,
        callback: (flag, msg) => {
          this.loginLoading = false;
          if (flag) {
            this.message = '登录成功！';
            // console.log('loginbu', this.backRoute)
            setTimeout(() => {
              if (this.backRoute) {
                this.$router.replace(this.backRoute);
              }
            }, 50);
          } else {
            this.message = msg || '登录失败！';
          }
        }
      });
    } else {
      this.message = this.resultok.message;
      this.loginLoading = false;
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push('/');
    },
  }
}
</script>
<style lang="less" scoped>
.site-container.weixin-container {
  overflow-y: auto;
}
.weixin-content {
  padding-top: 50px;
  text-align: center;
  h3 {
    padding: 1rem;
  }
  .login-message {
    padding: 2rem;
    font-size: 1.1rem;
    color: var(--focuscolor);
  }
}
</style>